import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Button, ButtonGroup, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';

const SplitButtonWithMenu = ({ label, menuOptions = [], startIcon, size = 'medium', onPrimaryClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null); // Reference to get the button's width

  const sizeStyleOverrides = () => {
    if (size === 'small') {
      return {
        paddingY: 1,
      };
    }

    if (size === 'medium') {
      return {
        paddingY: 2,
      };
    }
    if (size === 'large') {
      return {
        paddingY: 2.5,
      };
    }

    return {};
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (option) => {
    setAnchorEl(null);
    if (option?.onClick) {
      option.onClick();
    }
  };

  return (
    <ButtonGroup
      ref={buttonRef}
      sx={{
        '& .MuiButtonGroup-grouped:not(:last-of-type)': {
          '&:hover': {
            borderRightColor: '#C7D6DF', // color of border separating buttons
          },
        },
      }}>
      <Button
        fullWidth
        disableFocusRipple
        startIcon={startIcon}
        onClick={onPrimaryClick}
        sx={{
          color: (theme) => theme.palette.text.primary,
          textTransform: 'none',
          fontSize: '13px',
          border: '1.5px solid #C7D6DF',
          borderRadius: '10px',
          ...sizeStyleOverrides(),
          '&:hover': {
            backgroundColor: '#F3F8FB',
            border: '1.5px solid #C7D6DF',
          },
          '&:focus-visible': {
            backgroundColor: '#F3F8FB',
            border: '1.5px solid #C7D6DF',
          },
        }}>
        {label}
      </Button>
      <Button
        disableFocusRipple
        onClick={handleMenuClick}
        sx={{
          width: '70px',
          border: '1.5px solid #C7D6DF',
          borderRadius: '10px',
          ...sizeStyleOverrides(),
          '&:hover': {
            backgroundColor: '#F3F8FB',
            border: '1.5px solid #C7D6DF',
          },
          '&:focus-visible': {
            backgroundColor: '#F3F8FB',
            border: '1.5px solid #C7D6DF',
          },
        }}>
        {anchorEl ? (
          <ExpandLessRoundedIcon sx={{ color: '#3B6CAB' }} />
        ) : (
          <ExpandMoreRoundedIcon sx={{ color: '#3B6CAB' }} />
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleMenuClose()}
        PaperProps={{
          elevation: 0,
          sx: {
            width: buttonRef.current ? buttonRef.current.offsetWidth : 'auto', // Match width of split button
            marginTop: 1,
            border: '1.5px solid #C7D6DF',
            borderRadius: '10px',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        {menuOptions.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => handleMenuClose(option)}
            sx={{
              paddingY: 2,
              '&:hover': {
                backgroundColor: '#F3F8FB',
              },
              '&:focus-visible': {
                backgroundColor: '#F3F8FB',
              },
            }}>
            {option?.startIcon && <ListItemIcon>{option.startIcon}</ListItemIcon>}
            <ListItemText primaryTypographyProps={{ marginLeft: -1, fontSize: '13px', fontWeight: 500 }}>
              {option.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </ButtonGroup>
  );
};

export default SplitButtonWithMenu;
